module.exports = __webpack_public_path__ + "img/hamburger.1b7fc7d3.svg";